module.exports = __webpack_public_path__ + "img/main-logo.4c6f3468.svg";